import React, { useState, useEffect } from 'react';
import BootScreen from './components/BootScreen';
import Desktop from './components/Desktop';
import {
  initAutoClickTracking,
  initPageVisibilityTracking,
  initErrorTracking,
  trackPageView,
} from './analytics';
import './App.css';

function App() {
  const [isBooted, setIsBooted] = useState(false);

  useEffect(() => {
    // Initialize analytics tracking
    initAutoClickTracking();
    initPageVisibilityTracking();
    initErrorTracking();
    // Initial page view
    trackPageView(location.pathname + location.search);
  }, []);

  useEffect(() => {
    // Simulate boot time
    const timer = setTimeout(() => {
      setIsBooted(true);
    }, 2000); // 2 seconds - much faster

    return () => clearTimeout(timer);
  }, []);

  if (!isBooted) {
    return <BootScreen />;
  }

  return <Desktop />;
}

export default App;
